/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/CommentCard" />
import * as React from "react";
import { IDiscussionThreadModelProps } from "Repos/Discussion/DiscussionThread";
import { PullRequestDiscussion } from "Repos/Views/PullRequest/Discussion/Components/PullRequestDiscussion";
import {
    getPullRequestDiscussionService,
    IGitPullRequestCommentThreadModel
} from "Repos/Views/PullRequest/Discussion/PullRequestDiscussionThreadService";
import { newPullRequestThreadModel } from "Repos/Views/PullRequest/Discussion/PullRequestDiscussionUtil";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Persona, PersonaSize } from "VSSUI/Persona";
import { TextField } from "VSSUI/TextField";
import { css } from "VSSUI/Util";

export interface ICommentCardProps {
    isShim?: boolean;
    newInputRef: React.RefObject<TextField>;
    onAddComment?: () => void;
    onCancelComment?: () => void;
    onDeleteComment?: () => void;
    onUpdateComment?: () => void;
    threadModel?: IGitPullRequestCommentThreadModel;
}

export const CommentCard = (props: ICommentCardProps) => {
    const { pageContext } = useComponentContext();
    const { isShim, onAddComment, onCancelComment, onDeleteComment, onUpdateComment, threadModel } = props;
    const threadContext = getPullRequestDiscussionService(pageContext).getThreadContext();
    const [hasBeenCancelled, setCancelled] = React.useState(false);

    return (
        <Card
            className={css("repos-comment-card flex-row flex-grow bolt-card-no-vertical-padding", threadModel && "no-padding")}
            contentProps={{ className: threadModel ? undefined : "padding-vertical-16", contentPadding: !threadModel }}
        >
            {threadModel ? (
                <PullRequestDiscussion
                    author={threadContext.currentUser}
                    onPublishThread={onPublishThread}
                    onAddComment={onAddComment}
                    onDeleteThread={onDeleteThread}
                    onCancelComment={onCancelComment}
                    onDeleteComment={onDeleteComment}
                    onCancelThread={onDeleteThread}
                    onChangeStatus={onChangeStatus}
                    onUpdateComment={onUpdateComment}
                    permissions={threadContext.permissions}
                    personaProvider={threadContext.personaProvider}
                    pullRequestId={threadContext.pullRequestId}
                    repository={threadContext.repository}
                    thread={threadModel}
                    isShim={isShim}
                />
            ) : (
                <div className="flex-row flex-center flex-grow">
                    <Persona
                        className="margin-right-4"
                        identity={threadContext.currentUser}
                        personaProvider={threadContext.personaProvider}
                        size={PersonaSize.size24}
                    />
                    <TextField
                        autoFocus={hasBeenCancelled}
                        className="margin-left-8 repos-comment-editor-max-width"
                        containerClassName="flex-grow"
                        ref={props.newInputRef}
                        onClick={() => onStartThread()}
                        onChange={(e, value) => {
                            onStartThread(value);
                        }}
                        placeholder={Resources.AddAComment}
                    />
                </div>
            )}
        </Card>
    );

    function onStartThread(content?: string): void {
        setCancelled(false);
        const newThread = newPullRequestThreadModel({ onPersist: onPublishThread } as IDiscussionThreadModelProps);
        if (content) {
            newThread.getFirstComment().value.setContent(content);
        }
        getPullRequestDiscussionService(pageContext).addThread(newThread);
    }

    function onDeleteThread(threadId: number): void {
        getPullRequestDiscussionService(pageContext).removeThread(threadId);
        setCancelled(true);
    }

    function onPublishThread(threadId: number): void {
        getPullRequestDiscussionService(pageContext).updateThread(threadId);
    }

    function onChangeStatus(): void {
        getPullRequestDiscussionService(pageContext).updateThreadStatus();
    }
};

Components.add("ms.vss-code-web.comment-activity-card", CommentCard);
